import { FC, useEffect, useState } from "react"

import { IPostClassesTransactionsInput } from "api/reactQuery/mutations/classesTransactions.types"
import { useQueryHelpUpdateClassesStudents } from "api/reactQuery/queries/classesStudents"
import SendStoreChargeDialog from "components/module/storeCharge/sendStoreChargeDialog"
import { useDialog } from "hooks/dialog"
import { userUpdateBalanceClasslist } from "hooks/filter"
import { useClassId } from "hooks/navigation"
import { useAppDispatch, useAppSelector } from "hooks/store"
import { useNavigate } from "react-router"
import { RoutePath } from "routes/Route.types"
import { selectClassList } from "store/utility/utility.selectors"
import { setClassList } from "store/utility/utility.slice"
import { IObjectStudentDetailed } from "ts/interfaces/Student"

import TransactionsDialogForm from "../transactionsDialogForm"
import { ListItemActions } from "../ViewCommonElementsContainer.types"

interface IProps {
  action: {
    actionName: ListItemActions
    chosenItem: IObjectStudentDetailed
  } | null
  resetActionState: () => void
}

const ListItemActionsHandler: FC<IProps> = ({ action, resetActionState }) => {
  const { isOpen, handleClose, handleOpen } = useDialog()
  const {
    isOpen: isOpenStoreCharge,
    handleClose: handleCloseStoreCharge,
    handleOpen: handleOpenStoreCharge,
  } = useDialog()
  const navigate = useNavigate()
  const classId = useClassId()
  const [isUpdate, setIsUpdate] = useState(false)
  const [variables, setVariables] =
    useState<IPostClassesTransactionsInput | null>(null)
  const [storeChargeChargedIds, setStoreChargeChargedIds] = useState<
    number[] | null
  >(null)
  const dispatch = useAppDispatch()
  const [isClickOnButton, setIsClickOnButton] = useState(false)

  const classList = useAppSelector(selectClassList)

  const { data } = useQueryHelpUpdateClassesStudents({
    classId: Number(classId),
    page: 0,
    limit: 200,
    options: {
      enabled: isUpdate,
      cacheTime: 0,
      staleTime: 0,
    },
  })

  useEffect(() => {
    if (data && isClickOnButton) {
      const updatedClassList = userUpdateBalanceClasslist({
        classlist: classList,
        variable: storeChargeChargedIds
          ? { data: { student_ids: storeChargeChargedIds } }
          : variables,
        updatedClasslist: data?.data.objects,
      })

      dispatch(setClassList(updatedClassList))
      setIsUpdate(false)
      setVariables(null)
      setStoreChargeChargedIds(null)
      setIsClickOnButton(false)
    }
  }, [data])

  useEffect(() => {
    if (!action) return
    if (action.actionName === "sendTransaction") {
      setIsClickOnButton(true)
      handleOpen()
    }
    if (action.actionName === "sendStoreCharge") {
      handleOpenStoreCharge()
    }
    if (action.actionName === "visitProfile") {
      const mainContent = document.querySelector("main") as HTMLElement
      const mainScrollTop = mainContent?.scrollTop ?? 0
      const windowScrollTop = window.scrollY ?? 0
      const documentElementScrollTop = document.documentElement.scrollTop ?? 0
      const bodyScrollTop = document.body.scrollTop ?? 0
      const actualScrollPosition = windowScrollTop || documentElementScrollTop || bodyScrollTop || mainScrollTop
      if (mainContent) {
        sessionStorage.setItem("classListScrollPosition", String(mainContent.scrollTop))
      }
      sessionStorage.setItem("windowScrollPosition", String(actualScrollPosition))
      navigate(
        `${RoutePath.STUDENT.replace(":studentId", `${action.chosenItem.id}`)}`,
        { state: { classId: Number(classId) } }
      )
    }
  }, [action])

  if (!action) return null

  if (action.actionName === "sendStoreCharge") {
    return (
      <SendStoreChargeDialog
        isOpen={isOpenStoreCharge}
        entry="single"
        students={[action.chosenItem]}
        handleClose={() => {
          resetActionState()
          handleCloseStoreCharge()
        }}
        onCharged={(chargedStudentIds) => {
          handleCloseStoreCharge()
          resetActionState()
          if (chargedStudentIds.length > 0) {
            setStoreChargeChargedIds(chargedStudentIds)
            setIsClickOnButton(true)
            setIsUpdate(true)
          }
        }}
      />
    )
  }

  return (
    <TransactionsDialogForm
      setVariables={setVariables}
      isOpen={isOpen}
      action={action.actionName}
      defaultExpandedSections={["bonus"]}
      handleClose={() => {
        resetActionState()
        handleClose()
      }}
      studentsIds={[action.chosenItem.id]}
      onSuccess={() => {
        handleClose()
        resetActionState()
        setIsUpdate(true)
      }}
    />
  )
}

export default ListItemActionsHandler
